import axios from 'src/utils/axios';

export interface ManagedMember {
  id: number;
  first_name: string;
  last_name: string;
  initials: string;
  is_hoh: boolean;
  relationship_label: string;
  is_self: boolean;
}

export const getManagedMembers = (): Promise<ManagedMember[]> =>
  axios
    .get<{ members: ManagedMember[] }>('data-vault/managed-members/')
    .then((r) => r.data.members);
